import { useCallback } from 'react';
import { ControlProps } from '@jsonforms/core';
import { FormControlLabel, Checkbox } from '@mui/material';
import { withJsonFormsControlProps } from '@jsonforms/react';
import './BooleanControl.styles.scss';

export const BooleanControl = withJsonFormsControlProps((props: ControlProps) => {
  const { data, handleChange, path, label } = props;

  // Memoize change handler to prevent unnecessary re-renders
  const handleCheckboxChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    handleChange(path, e.target.checked);
  }, [handleChange, path]);

  return (
    <div className="rpc-boolean-control">
      <FormControlLabel
        control={
          <Checkbox
            checked={data || false}
            onChange={handleCheckboxChange}
          />
        }
        label={label}
      />
    </div>
  );
});
